var map = {
	"./bg-fade.jpg": 860,
	"./bg.png": 878,
	"./breadcrud.jpg": 329,
	"./css-notepad.jpg": 303,
	"./first-repo.jpg": 209,
	"./html-form.jpg": 65,
	"./mini-game.jpg": 401,
	"./montys-mineral-spa.jpg": 666,
	"./react-a-mole.jpg": 712,
	"./react-redux.jpg": 737,
	"./restrant.jpg": 638,
	"./self.png": 872,
	"./sequelizers-apparel.jpg": 424,
	"./whack-a-tag.jpg": 934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 594;